export default __webpack_public_path__ + "static/8-3108459f9eafd5c10318e93bcc0dca2b.png";